import React from 'react'

function WaveSection() {
  return (
    <div className="wave_container">
        <section id="waveSection">
            <div className="wave wave1"></div>
            <div className="wave wave2"></div>
            <div className="wave wave3"></div>
            <div className="wave wave4"></div>
        </section>
  </div>
  )
}


export default WaveSection
